import React from "react";
import { Checkbox, Grid, FormControl, FormControlLabel } from "@mui/material/";

export default ({ label, value, onChangeFn }) => {
    return (
        <Grid item xs={6}>
            <FormControl fullWidth margin="normal">
                <FormControlLabel
                    control={<Checkbox onChange={onChangeFn} checked={value} />}
                    label={label}
                />
            </FormControl>
        </Grid>
    );
};
